import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Loading } from '@/components/ui/loading';
import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';
import { getMfaRequirement } from '@/lib/mfa';

const AuthLayoutSecure = () => {
  const { user, loading } = useAuth();
  const [mfaChecked, setMfaChecked] = useState(false);
  const [canRedirect, setCanRedirect] = useState(false);

  useEffect(() => {
    let mounted = true;

    const checkAAL = async () => {
      if (!user) {
        if (mounted) {
          setMfaChecked(true);
          setCanRedirect(false);
        }
        return;
      }

      try {
        const { data: aalData } = await supabase.auth.mfa.getAuthenticatorAssuranceLevel();
        const { requiresMfa, hasVerifiedAssurance } = getMfaRequirement(aalData);
        const ok = !requiresMfa || hasVerifiedAssurance;

        if (mounted) {
          setCanRedirect(ok);
          setMfaChecked(true);
        }
      } catch (error) {
        console.error('Erro ao checar AAL no AuthLayout:', error);
        if (mounted) {
          setCanRedirect(false);
          setMfaChecked(true);
        }
      }
    };

    checkAAL();
    return () => {
      mounted = false;
    };
  }, [user]);

  if (loading) {
    return <Loading size="lg" variant="spinner" fullScreen text="Carregando..." />;
  }

  if (user && mfaChecked && canRedirect) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="w-full h-full">
      <Outlet />
    </div>
  );
};

export default AuthLayoutSecure;
